// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import style from "./OutputForm.module.scss";
import { getImageUrl } from "../../../../commons/assets_path";
import axios from "axios";
import { useTranslation } from "react-i18next";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

type Props = {
  label: object[];
  i: number;
  iconPath: string;
  isDisplayNameEditable: boolean;
  isTestValueEditable: boolean;
  template_class_name: string;
  clientCode: string;
};

export const OutputLabel = ({
  label,
  i,
  iconPath,
  isDisplayNameEditable,
  isTestValueEditable,
  template_class_name,
  clientCode,
}: Props) => {
  const { t } = useTranslation();
  const [labelValue, setLabelValue] = useState(label);
  const [editValue, setEditValue] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFileDownload, setShowFileDownload] = useState(false);
  const titleRef = useRef(null);
  const valueRef = useRef(null);

  const outputDuplicationCheck = async (name) => {
    await axios
      .post(
        location.href.replace(
          /workflow_templates.*/,
          `workflow_templates/${window.location.pathname.split("/")[3]}/ajax_output_duplication`,
        ),
        {
          target_display_name: name,
          target_id: labelValue?.target_id,
        },
      )
      .then((res) => {
        setEditValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: res.data.is_duplicated }));
        setLabelValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: res.data.is_duplicated }));
      });
  };
  const editLabel = () => {
    setEditValue(labelValue);
    setShowModal(true);
  };
  const submit = () => {
    setLabelValue(editValue);
    setShowModal(false);
  };
  const downloadFile = () => {
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.id = "no-before-unload";
    document.body.appendChild(hiddenInput);

    location.href = `${window.location.origin}/${clientCode}/workflow_templates/${label.workflow_template_id}/workflow_template_action_outputs/${label.id}/download`;

    setTimeout(() => {
      document.body.removeChild(hiddenInput);
    }, 1000);
  };

  useEffect(() => {
    if (editValue?.test_value) {
      const _copy = editValue.test_value.replace(/\n/g, " ");
      setEditValue((prevState) => ({ ...prevState, test_value: _copy }));
    }
    if (document.getElementsByName("set_trigger")[0]) {
      if (showModal) {
        document.getElementsByName("set_trigger")[0].disabled = true;
      } else {
        document.getElementsByName("set_trigger")[0].disabled = false;
      }
    }
  }, [showModal]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        className={`${style.outputLabelWrap} js-trigger-output- js-workflow_template_action_output_text_field`}
        style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", position: "relative" }}
        onMouseOver={() => {
          setShowEdit(true);
          setShowFileDownload(true);
        }}
        onMouseLeave={() => {
          setShowEdit(false);
          setShowFileDownload(false);
        }}
      >
        {labelValue.is_duplicated && (
          <img className={style.outputLabelIcon} src={getImageUrl("images/icons/informationRed.svg")}></img>
        )}
        {template_class_name === "web_meeting_trigger" ? (
          <img className={style.outputLabelIcon} src={getImageUrl(`images/icons/${iconPath}.svg`)}></img>
        ) : (
          <img className={style.outputLabelIcon} src={getImageUrl(`images/icons/operations/${iconPath}.svg`)}></img>
        )}
        <div className={`${style.outputLabelTitle} test_output_label_display_name`} ref={titleRef}>
          {labelValue.display_name}
        </div>
        {template_class_name !== "oem_operation_template" && template_class_name !== "mail_operation_template" && (
          <input
            className="form-control"
            data-target-id={label.target_id}
            value={labelValue.display_name}
            type="hidden"
            name={`${template_class_name}[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][display_name]`}
            id={`${template_class_name}_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_display_name`}
          />
        )}
        {template_class_name === "mail_trigger" && (
          <>
            <input
              className="form-control"
              data-target-id={label.target_id}
              value={labelValue.test_value}
              type="hidden"
              name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`}
              id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
            />
            <input
              className="form-control"
              data-target-id={label.target_id}
              value={labelValue?.target_id}
              type="hidden"
              name={`${template_class_name}[workflow_template_attributes][workflow_template_action_outputs_attributes][${i}][id]`}
              id={`${template_class_name}_workflow_template_attributes_workflow_template_action_outputs_attributes_${i}_id`}
            />
          </>
        )}
        {template_class_name === "document_issuance_operation_template" && (
          <input
            className="form-control"
            data-target-id={label.target_id}
            value={labelValue.test_value}
            type="hidden"
            name={`${template_class_name}[workflow_template_action_attributes][workflow_template_action_outputs_attributes][${i}][test_value]`}
            id={`${template_class_name}_workflow_template_action_attributes_workflow_template_action_outputs_attributes_${i}_test_value`}
          />
        )}
        <div
          className={`${style.outputLabelValue} test_output_label_test_value`}
          ref={valueRef}
          dangerouslySetInnerHTML={{ __html: labelValue.test_value }}
        />

        {(isDisplayNameEditable || isTestValueEditable) && showEdit && (
          <img
            className="test-edit_output_btn"
            src={getImageUrl("images/icons/editGray.svg")}
            style={{ cursor: "pointer" }}
            onClick={() => {
              editLabel();
            }}
          />
        )}
        {template_class_name === "rpa_operation_template" && label.data_type === "file" && showFileDownload && (
          <img
            className="test-edit_output_btn"
            src={getImageUrl("images/icons/download_2.svg")}
            style={{ cursor: "pointer" }}
            onClick={downloadFile}
          />
        )}
      </div>
      {showModal && (
        <div className={style.outputEditModal}>
          <div className={style.outputEditContent}>
            <div className={style.outputEditRow}>
              <div className={style.outputEditElement}>
                <div className={style.outputEditTitle}>{t("OutputLabel.項目名")}</div>
                <input
                  className={`${style.outputEditInput} ${
                    editValue.is_duplicated && "output-duplication-warning"
                  } output_display_name-test`}
                  value={editValue.display_name}
                  readOnly={!isDisplayNameEditable}
                  style={{
                    color: !isDisplayNameEditable && "#777777",
                    backgroundColor: !isDisplayNameEditable && "#F3F3F3",
                  }}
                  onChange={(e) => {
                    const _copy = JSON.parse(JSON.stringify(editValue));
                    _copy.display_name = e.target.value;
                    setEditValue(_copy);
                    outputDuplicationCheck(e.target.value);
                  }}
                />
                {editValue.is_duplicated && (
                  <div className="output-duplication-warning-feedback">
                    {t(
                      "OutputLabel.項目名が重複しています。項目名が重複している場合、値が上書きされますのでご注意ください。",
                    )}
                  </div>
                )}
              </div>
              <div className={style.outputEditElement}>
                <div className={style.outputEditTitle}>{t("OutputLabel.テストで取得した値")}</div>
                <input
                  className={`${style.outputEditInput} output_test_value-test`}
                  readOnly={!isTestValueEditable}
                  style={{
                    color: !isTestValueEditable && "#777777",
                    backgroundColor: !isTestValueEditable && "#F3F3F3",
                  }}
                  defaultValue={editValue.test_value}
                  onChange={(e) => {
                    const _copy = JSON.parse(JSON.stringify(editValue));
                    _copy.test_value = e.target.value;
                    setEditValue(_copy);
                  }}
                ></input>
              </div>
            </div>
          </div>
          <div className={style.outputEditButtonRow}>
            <div
              className="btn btn-secondary cancel_output_btn-test"
              style={{ fontSize: "16px", padding: "6px", height: "44px" }}
              onClick={() => {
                setShowModal(false);
                document.getElementsByName("set_trigger")[0].disabled = false;
                setEditValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: false }));
                setLabelValue((prevLabelValue) => ({ ...prevLabelValue, is_duplicated: false }));
              }}
            >
              {t("OutputLabel.キャンセル")}
            </div>
            <button
              className="btn btn-info test_save_output_btn"
              style={{
                fontSize: "16px",
                padding: "6px",
                height: "44px",
              }}
              disabled={!editValue.display_name}
              onClick={() => {
                submit();
              }}
            >
              {t("OutputLabel.保存")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
